import { useMutation } from '@apollo/client'
import { loader } from 'graphql.macro'
import { LanguageEnum } from 'enums'
import { serviceEndpoints } from 'variables/services'

const MUTATION_DOCUMENT = loader('./setUserPreferences.gql')
const { liffAPI } = serviceEndpoints

interface SetUserPreferencesData {
  setUserPreferences: {
    id: number
    language: string
  }
}

interface SetUserPreferencesVar {
  language: LanguageEnum
}

function useSetUserPreferences(accessToken) {
  return useMutation<SetUserPreferencesData, SetUserPreferencesVar>(MUTATION_DOCUMENT, {
    context: {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      uri: liffAPI,
    },
  })
}

export default useSetUserPreferences
